import React from 'react';
import { useTranslation } from 'react-i18next';
import { QBox, QText, QFlex, QTag } from '@qualio/ui-components';
import { StepDocument } from '../../../types/eventStep';
import { useLocalisedFormatDateTime } from '../../../utils/datetimeUtils';

type ContentStepMetadataProps = {
  document: StepDocument | undefined;
};

const ContentStepMetadata: React.FC<ContentStepMetadataProps> = ({ document }) => {
  const { t } = useTranslation();
  const formatDateTime = useLocalisedFormatDateTime();
  const createItem = (label: string, children: React.ReactNode) => {
    return (
      <QBox mr={10}>
        <QBox>
          <QText fontWeight="semibold" fontSize="xs" color="gray.800">
            {label}
          </QText>
        </QBox>
        <QBox>{children}</QBox>
      </QBox>
    );
  };

  const emptyString = '--';

  const contentStatus = (stepDocument: StepDocument | undefined) => {
    if (stepDocument) {
      return <QTag variantColor="gray">{stepDocument.status}</QTag>;
    }
    return emptyString;
  };

  return (
    <QBox h="70px" borderColor="gray.200" borderBottomWidth="1px">
      <QFlex h="100%" ml={4} direction="row" align="center">
        {createItem(t('common.labels.status'), contentStatus(document))}
        {createItem(t('common.labels.version'), document ? `${document.version}` : emptyString)}
        {createItem(t('common.labels.assignedTo'), document ? document.author_full_name : emptyString)}
        {createItem(t('common.labels.lastModified'), document ? formatDateTime(document.modified_time) : emptyString)}
      </QFlex>
    </QBox>
  );
};

export default ContentStepMetadata;
